var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"banner",staticClass:"banner-container full-width"},[_c('div',{staticClass:"img-wrapper front",style:(_vm.getMaskStyle)}),_c('div',{staticClass:"img-wrapper back"})])}
var staticRenderFns = []

export { render, staticRenderFns }